module.exports = __webpack_public_path__ + "img/153.6eaa983f.jpg";